
import React, { forwardRef, useState, useCallback, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';
import { uniqBy } from 'lodash';

const DataTheoremMappingForm = forwardRef(function DataTheoremMappingForm(props, ref){
    const [options,setOptions] = useState(() => {
        if (props.record) {
          const { mobileAppId, mobileAppName } = props.record;
          return [{id: mobileAppId, name: mobileAppName}]
        }
        return [];
      });
    const [form] = Form.useForm();

    const setOptionsFromPagination = (option) => {
        setOptions(prev => uniqBy([...prev,...option], 'id'));
    }

    const fetchRepos = useCallback((params) => {
        const { promise,cancel } =  ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, params);
        promise.then((data) => setOptionsFromPagination(data.projects))
        return { promise,cancel}
    }, [props.toolName]);

    const getExtraFieldsData = useCallback((config) => {
        const { mobileAppId } = config;
        const mobileAppName = options.find(m => m.id === mobileAppId).name
        return ({mobileAppId, mobileAppName: mobileAppName});
    }, [options]);

    const parseExtraFieldsDataFromResponse = useCallback((config) => {
        return { 
            mobileAppId: config.mobileAppId.split(','),
        };
      }, []);

    const projectChangeHandler = useCallback((value, field,selectValue) => {
        const { name } = field;
        const configurations = form.getFieldValue("configurations");
        let updatedConfiguration = [
            ...configurations
        ];
        updatedConfiguration[name] = {
            ...updatedConfiguration[name],
        }
        form.setFieldsValue({ configurations: updatedConfiguration })
    }, [form])

    const extraFields = useMemo(() => ([
        {
          name: 'mobileAppId',
          colSpan: '10',
          type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
          label: 'Mobile App',
          props: {
            api: fetchRepos,
            onChange: projectChangeHandler,
            apiParams: {login_id: props.loginConfigId, },
            autoFocus: true
          },
          rules: [{ required: true, message: 'Mobile App is required' }]
        }
      ]), [fetchRepos, props.loginConfigId, projectChangeHandler]);

    return (
        <GenericMappingForm
            form={form}
            title={"Map Data Theorem Mobile Applications"}
            ref={ref}
            extraFields={extraFields}
            getExtraFieldsData={getExtraFieldsData}
            parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
            {...props}
        />
    )
});

export default DataTheoremMappingForm;